import { useContext } from 'react';

import { BaseAuthContext } from './context';

export function useBaseAuth() {
  return useContext(BaseAuthContext);
}

export function useBaseAuthenticated() {
  const { currentMembership, user, ...rest } = useBaseAuth();

  if (!user || !currentMembership) {
    throw new Error(
      `Either user and/or currentMembership are/is not defined. You can only use this hook only if component is protected against unauthenticated users.`,
    );
  }

  return { currentMembership, user, ...rest };
}
